import { formatDate } from "date-fns";
import { toast } from "react-toastify";
import { MenuItem } from '@headlessui/react'
import React, { useEffect, useState } from "react"

import { ASSETS } from "../../api/Registry"
import { AddAttribute } from "./AddAttribute"
import DropDown from "../../lib/fragments/DropDown"
import { APPLICATION } from "../../utils/Constants";
import HttpServices from "../../services/HttpServices"
import { RouteHydration } from "../../utils/Helpers"
import { Loading } from "../../components/utils/Loading"
import { SortableList } from '../../lib/dnd/SortableList'
import { DatePicker } from '../../components/utils/DatePicker'
import { InputBasic } from '../../components/utils/InputBasic'
import { RadioButton } from "../../components/utils/RadioButton";
import { InputTextArea } from '../../components/utils/InputTextArea'
import { SingleActionModal } from '../../lib/fragments/SingleActionModal'
import { AssetFormPreview } from "./AssetFormPreview";

export const Attributes = ({ category, type }) => {
    const [state, setstate] = useState({
        posting: false,
        httpStatus: 200,
        defaultDate: '',
        status: 'pending',
        data: {

        },
        show: {
            addAttribute: false,
            preview: false,
        },
        input: {
            date: '',
            dateUTC: null
        }, errors: {
            date: ''
        }
    })

    const unpublishedChoices = [
        {
            key: "resume",
            label: "Resume Editing",
            subtitle: "Pick up from the existing draft and make further changes"
        },
        {
            key: "discard",
            label: "Discard Changes",
            subtitle: "Remove the draft and revert to the last published version"
        }
    ]

    const payloadMapping = {
        k: 'label',
        b: 'block',
        s: 'subtitle',
        p: 'properties',
        idg: 'id',
    };

    const [attributeList, setAttributeList] = useState(null)

    const [draftProps, setDraftProps] = React.useState({
        exists: false,
        action: "",
    })

    useEffect(() => {
        if (type) {
            const fetchAssetTypeForm = async () => {
                setstate((prevState: any) => ({
                    ...prevState,
                    status: 'pending'
                }))

                let forms = null
                let { status } = state
                let { httpStatus } = state

                try {
                    let response: any = null
                    let assetFormRoute = null

                    assetFormRoute = RouteHydration(ASSETS.ASSET_FORMS, ':category', category.uuid)
                    assetFormRoute = RouteHydration(assetFormRoute, ':type', type.uuid)

                    response = await HttpServices.httpGet(assetFormRoute)
                    httpStatus = response.status

                    if (httpStatus === 200) {
                        let draftedData = []
                        const payload: any = response.data.payload

                        payload.data.forEach((draft) => {
                            // Iterate through the `data` array and map the keys to their full names
                            const mappedDraft = {};

                            Object.keys(draft).forEach((key) => {
                                // Map short keys to full names
                                mappedDraft[payloadMapping[key]] = draft[key];
                            });

                            draftedData.push(mappedDraft)
                        });

                        status = 'fulfilled'
                        setAttributeList(draftedData)
                        const showDraftActionModal = (payload.status && !payload.echo) ? true : false

                        setDraftProps((prevProps: any) => ({
                            ...prevProps,
                            exists: showDraftActionModal
                        }));
                    } else {
                        status = 'rejected'
                    }
                } catch (error) {
                    status = 'rejected'
                    httpStatus = 500
                }

                // Set default date for date picker
                const defaultDate = new Date()
                const defaultDateString = formatDate(defaultDate, "dd/MM/yyyy")

                const defaultDateInUTC = new Date(
                    Date.UTC(defaultDate.getFullYear(), defaultDate.getMonth(), defaultDate.getDate())
                ).toISOString();

                setstate((prevState: any) => ({
                    ...prevState, status,
                    httpStatus,
                    defaultDate: defaultDateString,
                    data: {
                        ...prevState.data,
                        forms: forms,
                    },
                    input: {
                        ...prevState.input,
                        date: defaultDateString,
                        dateUTC: defaultDateInUTC
                    }
                }));
            }

            fetchAssetTypeForm()
        }
    }, [category, type])

    const toggleAddAttributeModal = () => {
        setstate((prev) => ({
            ...prev,
            show: {
                ...prev.show,
                addAttribute: !prev.show.addAttribute
            }
        }))
    }

    const onAddAttributeComplete = (actionData: any) => {
        toggleAddAttributeModal()
        console.log('On Complete', actionData);
    }

    const getReorderedList = async (reorderedAttr: any) => {
        setAttributeList(reorderedAttr)

        console.log('Reordered', reorderedAttr);
    }

    const onDatePickerHandler = (e: any, close: () => void) => {
        let posting = false

        if (!posting) {
            let { input } = state
            let { errors } = state

            console.log('State: X0', attributeList[3]);

            // Convert to UTC, ensuring time is set to 00:00:00 UTC
            const dateString = new Date(e)
            const dateStringInUTC = new Date(
                Date.UTC(dateString.getFullYear(), dateString.getMonth(), dateString.getDate())
            )

            const displayFormat = formatDate(dateStringInUTC, "dd/MM/yyyy")

            const updatedInput = {
                ...input,
                date: displayFormat,
                dateUTC: dateStringInUTC
            };

            const updatedErrors = {
                ...errors,
                date: ''
            };

            setstate((prev) => ({
                ...prev,
                input: updatedInput,
                errors: updatedErrors,
            }));
        }

        close()
    }

    const handleSelection = (event: any) => {
        let { posting } = state

        if (!posting) {
            setDraftProps((prevProps: any) => ({
                ...prevProps,
                action: event.target.value
            }));
        }
    };

    const onConsentAction = async () => {
        if (draftProps.action === 'resume') {
            /* 
             * No action needed.
             * Close modal
            */

            setDraftProps((prevState: any) => ({
                ...prevState,
                exists: false
            }));
        } else if (draftProps.action === 'discard') {
            setstate((prevState: any) => ({
                ...prevState,
                posting: true
            }));

            try {
                let httpStatus = 200
                let response: any = null
                let draftDiscardRoute = null

                draftDiscardRoute = RouteHydration(ASSETS.DISCARD_DRAFT, ':category', category.uuid)
                draftDiscardRoute = RouteHydration(draftDiscardRoute, ':type', type.uuid)

                response = await HttpServices.httpPost(draftDiscardRoute, null)
                httpStatus = response.status

                if (httpStatus === 200) {
                    let draftedData = []
                    const payload: any = response.data.payload

                    payload.data.forEach((draft: any) => {
                        // Iterate through the `data` array and map the keys to their full names
                        const mappedDraft = {};

                        Object.keys(draft).forEach((key) => {
                            // Map short keys to full names
                            mappedDraft[payloadMapping[key]] = draft[key];
                        });

                        draftedData.push(mappedDraft)
                    });

                    setAttributeList(draftedData)

                    setstate((prevState: any) => ({
                        ...prevState,
                        posting: false
                    }));

                    setDraftProps((prevState: any) => ({
                        ...prevState,
                        exists: false
                    }));
                } else {
                    toast.error(APPLICATION.ERR_MSG, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                }
            } catch (error) {
                toast.error(APPLICATION.ERR_MSG, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            }
        }
    }

    const togglePreviewModal = () => {
        setstate((prev) => ({
            ...prev,
            show: {
                ...prev.show,
                preview: !prev.show.preview
            }
        }))
    }

    const publishAssetForm = async () => {
        let httpStatus = 200

        try {
            let response: any = null
            let publishingRoute = null

            publishingRoute = RouteHydration(ASSETS.PUBLISH_FORM, ':category', category.uuid)
            publishingRoute = RouteHydration(publishingRoute, ':type', type.uuid)

            response = await HttpServices.httpPost(publishingRoute, null)
            httpStatus = response.status

            if (httpStatus === 200) {
                const payload: any = response.data.payload
            } else {
                // status = 'rejected'
            }
        } catch (error) {
            // status = 'rejected'
            httpStatus = 500
        }
    }

    return (
        <React.Fragment>
            {
                type ? (
                    <>
                        <div className="w-full h-full lg:w-2/3 overflowy-y-auto rounded-md mx-auto flex flex-col gap-y-2 relative">
                            {/* Fixed Section at the Top */}
                            <div className="md:stiky top- md:z-[] pb-1 px-4">
                                <div className="w-full">
                                    <p className="text-lg pb-2 text-slate-900 dark:text-white font-medium tracking-wider text-start md:hidden">
                                        {type.name}
                                    </p>

                                    <p className="text-sm text-wrap text-slate-500 dark:text-slate-300">
                                        {type.description}
                                    </p>
                                </div>

                                <div className="w-full flex flex-row items-center align-middle gap-x-2 pt-2 pb-2">
                                    <div className="flex-1 float-right flex flex-row-reverse align-middle items-center gap-x-2">
                                        <div className="flex-none">
                                            <DropDown
                                                type={'bordered'}
                                                items={
                                                    <div className="text-sm w-48 flex flex-col gap-y-1">
                                                        <MenuItem>
                                                            <button type="button" className="w-full flex gap-x-3 items-center rounded-md px-2 py-2 text-sm text-primary data-[focus]:bg-gray-200 data-[focus]:text-secondary">
                                                                <div className="flex-none w-1/4 flex items-center justify-center">
                                                                    <span className="fa-light fa-pen-to-square fa-lg block"></span>
                                                                </div>

                                                                <span className="w-3/4 text-start">Edit</span>
                                                            </button>
                                                        </MenuItem>

                                                        <span className="border-b border-slate-300 dark:border-slate-600  mx-3"></span>

                                                        <MenuItem>
                                                            <button type="button" className="w-full flex gap-x-3 items-center rounded-md px-2 py-2 text-sm text-red-600 data-[focus]:bg-red-200 data-[focus]:text-red-700">
                                                                <div className="flex-none w-1/4 flex items-center justify-center">
                                                                    <span className="fa-light fa-trash fa-lg block"></span>
                                                                </div>
                                                                <span className="w-3/4 text-start">Decommission</span>
                                                            </button>
                                                        </MenuItem>

                                                        <MenuItem>
                                                            <button type="button" className="w-full flex gap-x-3 items-center rounded-md px-2 py-2 text-sm text-primary data-[focus]:bg-gray-200 data-[focus]:text-secondary">
                                                                <div className="flex-none w-1/4 flex items-center justify-center">
                                                                    <span className="fa-light fa-circle-info fa-lg block"></span>
                                                                </div>

                                                                <span className="w-3/4 text-start">Help</span>
                                                            </button>
                                                        </MenuItem>
                                                    </div>
                                                }
                                            />
                                        </div>

                                        <span className="border-l py-3 border-slate-300 dark:border-slate-600 "></span>

                                        <button type="button" onClick={publishAssetForm} className="flex flex-row align-middle items-center bg-primary disabled:cursor-not-allowed py-1 px-2.5 rounded-md text-white gap-x-1.5 text-sm">
                                            <span className="text-sm">Publish</span>
                                            <span className="fa-duotone fa-circle-check"></span>
                                        </button>

                                        <button type="button" onClick={togglePreviewModal} className="flex flex-row align-middle items-center bg-inherit disabled:cursor-not-allowed py-1 px-2.5 rounded-md text-gray-600 gap-x-1.5 text-sm hover:bg-slate-200">
                                            <span className="fa-duotone fa-eye"></span>
                                            <span className="text-sm">Preview</span>
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* Scrollable Section */}
                            <div className="flex-1 overflow-y-uto">
                                {
                                    state.status === 'rejected' ? (
                                        <>

                                        </>
                                    ) : state.status === 'fulfilled' ? (
                                        <>
                                            <div className="lg:w-23 w-full h-full mx-auto">
                                                <div className="px-4">
                                                    <button type="button" onClick={toggleAddAttributeModal} className="flex flex-row align-middle items-center gap-x-1.5 text-orange-600 hover:text-orange-700">
                                                        <span className="fa-solid fa-plus"></span>
                                                        <span className="block">Add an attribute</span>
                                                    </button>

                                                    <div className="py-2 md:w-60">
                                                        <DatePicker
                                                            value={state.input.date}
                                                            error={state.errors.date}
                                                            label={'Pick a date'}
                                                            name={'date'}
                                                            blurHandler={undefined}
                                                            disabled={false}
                                                            required={false}
                                                            changeHandler={onDatePickerHandler}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="main-body p-4 pb-20">
                                                    {(() => {
                                                        let sectionCounter = 0
                                                        let closingRemarks = null

                                                        let blockItemsArray = []
                                                        let sectionBlockArray = []

                                                        attributeList.forEach((attr: any) => {
                                                            if (attr.block === 'section') {
                                                                sectionBlockArray.push({ label: attr.label, id: attr.id })
                                                            }

                                                            blockItemsArray.push({ block: attr.id })
                                                        });

                                                        return (
                                                            <SortableList
                                                                items={attributeList}
                                                                onChange={(newItems) => getReorderedList(newItems)}
                                                                renderItem={(attributeData: any) => {
                                                                    let blockItemPosition = blockItemsArray.findIndex(obj => obj.block === attributeData.id)

                                                                    closingRemarks = (
                                                                        <>
                                                                            <div key={`action-break-${attributeData.id}`} className="section-children bg-white dark:bg-slate-900 p-2 shadow rounded-b-md">
                                                                                <div className="child-item py-2 px-2 border-b last:border-b-0 text-sm">
                                                                                    <button type="button" onClick={toggleAddAttributeModal} className="flex flex-row align-middle items-center gap-x-1.5 text-orange-600 hover:text-orange-700">
                                                                                        <span className="fa-solid fa-plus"></span>
                                                                                        <span className="block">Add an attribute</span>
                                                                                    </button>
                                                                                </div>
                                                                            </div>

                                                                            <div key={`page-break-${attributeData.id}-opening`} className="page-break bg-inherit h-6"></div>
                                                                        </>
                                                                    )

                                                                    if (attributeData.block === 'section') {
                                                                        sectionCounter = sectionBlockArray.findIndex(obj => obj.label === attributeData.label);

                                                                        return (
                                                                            <>
                                                                                {
                                                                                    sectionCounter > 0 ? (
                                                                                        <>
                                                                                            {closingRemarks}
                                                                                        </>
                                                                                    ) : null
                                                                                }

                                                                                <div key={`section-start-${attributeData.id}`} className="section-heading bg-white dark:bg-slate-900 shadow rounded-t-md pb-3">
                                                                                    <div className="py-1 mb-2 text-sm bg-slate-100 dark:bg-slate-800 text-slate-700 w-full rounded-t-md dark:text-slate-500 px-3">
                                                                                        Section {sectionCounter + 1}
                                                                                    </div>

                                                                                    <div className="w-full px-3">
                                                                                        <h2 className="text-lg tracking-wide text-slate-700 dark:text-slate-300 pb-1">
                                                                                            {attributeData.label}
                                                                                        </h2>

                                                                                        <p className="block w-full pb-2 text-xs text-slate-500 dark:text-slate-400">
                                                                                            {attributeData.subtitle}
                                                                                        </p>
                                                                                    </div>
                                                                                </div>

                                                                                {
                                                                                    blockItemPosition === (blockItemsArray.length - 1) ? (
                                                                                        <>
                                                                                            {closingRemarks}
                                                                                        </>
                                                                                    ) : null
                                                                                }
                                                                            </>
                                                                        )
                                                                    } else {
                                                                        return (
                                                                            <>
                                                                                <div key={attributeData.id} className="px-3 bg-white dark:bg-slate-900 cursor-pointr py- shadow">
                                                                                    <SortableList.Item id={attributeData.id}>
                                                                                        <SortableList.DragHandle />

                                                                                        {(() => {
                                                                                            let attrProps: any;

                                                                                            try {
                                                                                                attrProps = JSON.parse(attributeData.properties || "{}");
                                                                                            } catch {
                                                                                                console.error("Failed to parse attribute properties");
                                                                                                attrProps = {};
                                                                                            }

                                                                                            // Initialize default properties
                                                                                            const defaultProperties = {
                                                                                                mandatory: attrProps.mandatory || false,
                                                                                                placeholder: "Sample text input",
                                                                                                data_type: {
                                                                                                    name: "",
                                                                                                    icon: "",
                                                                                                },
                                                                                            };

                                                                                            // console.log('attrProps', attrProps);
                                                                                            // console.log('properties', properties);

                                                                                            const resolveProperties = (block: string) => {
                                                                                                const properties = { ...defaultProperties };

                                                                                                switch (block) {
                                                                                                    case "text_field":
                                                                                                        properties.placeholder =
                                                                                                            attrProps.restrictions?.name === "Alphanumeric" && attrProps.multiline ? "Sample text description"
                                                                                                                : attrProps.restrictions?.name === "Alphanumeric" ? "Sample text input"
                                                                                                                    : attrProps.restrictions?.name === "Numerical" ? "Number format 123"
                                                                                                                        : "URL";

                                                                                                        properties.data_type = attrProps.restrictions || {};
                                                                                                        break;

                                                                                                    case "date_picker":
                                                                                                        properties.placeholder = 'Pick a date'
                                                                                                        properties.data_type = { icon: "fa-calendar", name: "Date" };
                                                                                                        break;

                                                                                                    case "choice_control":
                                                                                                        properties.data_type = {
                                                                                                            icon: "fa-ballot-check",
                                                                                                            name: attrProps.display?.type || "Choice",
                                                                                                        };
                                                                                                        break;

                                                                                                    default:
                                                                                                        console.warn(`Unhandled block type: ${block}`);
                                                                                                        break;
                                                                                                }

                                                                                                return properties;
                                                                                            };

                                                                                            const properties = resolveProperties(attributeData.block);

                                                                                            const labelSubtitle = (
                                                                                                <div className="w-full md:mb-3">
                                                                                                    <div className="w-full flex text-sm flex-row items-center align-middle gap-x-2 pb-1">
                                                                                                        <h3 className="flex-grow dark:text-slate-300">
                                                                                                            {attributeData.label}:

                                                                                                            {
                                                                                                                properties.mandatory ? (
                                                                                                                    <sup className="text-red-500">*</sup>
                                                                                                                ) : null
                                                                                                            }
                                                                                                        </h3>
                                                                                                    </div>

                                                                                                    {
                                                                                                        attributeData.subtitle && (
                                                                                                            <div className="text-xs flex-grow text-muted dark:text-slate-400">
                                                                                                                <span className="block text-xs">{attributeData.subtitle}</span>
                                                                                                            </div>
                                                                                                        )
                                                                                                    }
                                                                                                </div>
                                                                                            )

                                                                                            return (
                                                                                                <div className="text-sm w-full px-1 py-1 flex flex-col bg-emrald-100 pt-2">
                                                                                                    {
                                                                                                        attributeData.block === "text_field" ? (
                                                                                                            <>
                                                                                                                <div className="w-full md:mb-2">
                                                                                                                    {
                                                                                                                        attrProps.multiline ? (
                                                                                                                            <>
                                                                                                                                <InputTextArea
                                                                                                                                    name={attributeData.id}
                                                                                                                                    required={false}
                                                                                                                                    label={labelSubtitle}
                                                                                                                                    posting={true}
                                                                                                                                    value={undefined}
                                                                                                                                    error={[]}
                                                                                                                                    placeHolder={properties.placeholder}
                                                                                                                                    blurHandler={undefined}
                                                                                                                                    changeHandler={undefined}
                                                                                                                                />
                                                                                                                            </>
                                                                                                                        ) : (
                                                                                                                            <>
                                                                                                                                <InputBasic
                                                                                                                                    name={attributeData.id}
                                                                                                                                    required={false}
                                                                                                                                    label={labelSubtitle}
                                                                                                                                    posting={true}
                                                                                                                                    value={undefined}
                                                                                                                                    error={[]}
                                                                                                                                    placeHolder={properties.placeholder}
                                                                                                                                    blurHandler={undefined}
                                                                                                                                    changeHandler={undefined}
                                                                                                                                />
                                                                                                                            </>
                                                                                                                        )
                                                                                                                    }
                                                                                                                </div>
                                                                                                            </>
                                                                                                        ) : attributeData.block === "date_picker" ? (
                                                                                                            <>
                                                                                                                <DatePicker
                                                                                                                    value={state.defaultDate}
                                                                                                                    error={''}
                                                                                                                    label={labelSubtitle}
                                                                                                                    name={'date'}
                                                                                                                    placeHolder={properties.placeholder}
                                                                                                                    blurHandler={undefined}
                                                                                                                    disabled={true}
                                                                                                                    required={false}
                                                                                                                    changeHandler={undefined}
                                                                                                                />
                                                                                                            </>
                                                                                                        ) : attributeData.block === "choice_control" ? (
                                                                                                            <>
                                                                                                                <div className="block text-sm leading-6 text-primary-dark dark:text-slate-400 mb-3 md:mb-0">
                                                                                                                    {labelSubtitle}
                                                                                                                </div>

                                                                                                                <ul className="space-y-3">
                                                                                                                    {
                                                                                                                        attrProps.options.map((option: any, index: any) => {
                                                                                                                            return (
                                                                                                                                <div key={`option-${index}-lst-${option.label}`} aria-disabled={true}>
                                                                                                                                    <li className="pointer-events-auto w-full rounded-md px-3 bg-inherit text-[0.8125rem]/5 shadow-x shadow-black/5 ring- ring-stone-300">
                                                                                                                                        <div className="flex items-center bg-yellow-10 w-full gap-x-3 py-0.5">
                                                                                                                                            {
                                                                                                                                                attrProps.display.type === 'Checkboxes' ? (
                                                                                                                                                    <span className="fill-inherit stroke-slate-400 dark:stroke-slate-700 w-5 h-5">
                                                                                                                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="fill-current">
                                                                                                                                                            <rect width="19" height="19" x="2.5" y="2.5" className="fill-white dark:fill-slate-700" rx="1.5"></rect>
                                                                                                                                                        </svg>
                                                                                                                                                    </span>
                                                                                                                                                ) : attrProps.display.type === 'Radio Buttons' ? (
                                                                                                                                                    <span className="fill-inherit stroke-slate-400 dark:stroke-slate-700 w-5 h-5">
                                                                                                                                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                                                                                                                                            <path className="fill-white dark:fill-slate-700" d="M12 21.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19Z"></path>
                                                                                                                                                        </svg>
                                                                                                                                                    </span>
                                                                                                                                                ) : null
                                                                                                                                            }

                                                                                                                                            <div className="font-medium text-slate-700 dark:text-slate-400">
                                                                                                                                                <p className="block">
                                                                                                                                                    {option.label.replace(" [SYS]", "")}
                                                                                                                                                </p>
                                                                                                                                            </div>
                                                                                                                                        </div>

                                                                                                                                        <div className="mt-1 text-slate-500">
                                                                                                                                            {option.hint}
                                                                                                                                        </div>
                                                                                                                                    </li>
                                                                                                                                </div>
                                                                                                                            )
                                                                                                                        })
                                                                                                                    }
                                                                                                                </ul>
                                                                                                            </>
                                                                                                        ) : (
                                                                                                            <>
                                                                                                                <div className="w-full flex flex-row items-center align-middle gap-x-2" aria-disabled={true}>
                                                                                                                    <div className="w-7 h-auto flex justify-center items-center">
                                                                                                                        <span className={`fa-light ${properties.data_type.icon} fa-lg`}></span>
                                                                                                                    </div>
                                                                                                                    <h3 className="md:text-base flex-grow">{attributeData.label}</h3>
                                                                                                                </div>

                                                                                                                <div className="md:text-sm text-base flex-grow text-muted dark:text-slate-400 py-1">
                                                                                                                    <span className="block text-xs">{attributeData.subtitle || "-"}</span>
                                                                                                                </div>
                                                                                                            </>
                                                                                                        )
                                                                                                    }

                                                                                                    <div className="w-full py-1 flex items-center flex-row-reverse gap-x-2">
                                                                                                        <div className="flex-none">
                                                                                                            <DropDown
                                                                                                                type={'borderless'}
                                                                                                                items={
                                                                                                                    <div className="text-sm w-48 flex flex-col">
                                                                                                                        <MenuItem>
                                                                                                                            <button type="button" className="w-full flex gap-x-3 items-center align-middle rounded-md px-2 py-2 text-sm text-primary dark:text-slate-400 dark:data-[focus]:bg-slate-700 data-[focus]:bg-gray-200 data-[focus]:text-secondary">
                                                                                                                                <div className="flex-none w-9 flex items-center justify-center">
                                                                                                                                    <span className="fa-light fa-pen-to-square fa-lg block"></span>
                                                                                                                                </div>

                                                                                                                                <span className="flex-grow text-start">Edit Attribute</span>
                                                                                                                            </button>
                                                                                                                        </MenuItem>

                                                                                                                        <MenuItem>
                                                                                                                            <button type="button" className="w-full flex gap-x-3 items-center rounded-md px-2 py-2 text-sm text-red-600 dark:data-[focus]:bg-slate-700 data-[focus]:bg-red-200 data-[focus]:text-red-700">
                                                                                                                                <div className="flex-none w-9 flex items-center justify-center">
                                                                                                                                    <span className="fa-light fa-trash fa-lg block"></span>
                                                                                                                                </div>

                                                                                                                                <span className="wflex-grow text-start">Disable</span>
                                                                                                                            </button>
                                                                                                                        </MenuItem>
                                                                                                                    </div>
                                                                                                                }
                                                                                                            />
                                                                                                        </div>

                                                                                                        <span className="border-l border-slate-300 dark:border-slate-600 py-3"></span>

                                                                                                        <div className="flex-none flex flex-row-reverse items-center align-middle gap-x-2 text-muted">
                                                                                                            <div className="w-7 h-auto flex justify-center items-center">
                                                                                                                <span className={`fa-light ${properties.data_type.icon} fa-lg`}></span>
                                                                                                            </div>
                                                                                                            <h3 className="text-xs flex-none">{properties.data_type.name}</h3>
                                                                                                        </div>

                                                                                                        {
                                                                                                            properties.mandatory && (
                                                                                                                <div className="flex-grow flex items-center gap-x-0.5 text-red-500">
                                                                                                                    <div className="w-6 flex justify-center items-center">
                                                                                                                        <span className={`fa-light fa-circle-exclamation`}></span>
                                                                                                                    </div>
                                                                                                                    <h3 className="text-xs flex-none">Required</h3>
                                                                                                                </div>
                                                                                                            )
                                                                                                        }

                                                                                                    </div>
                                                                                                </div>
                                                                                            );
                                                                                        })()}

                                                                                    </SortableList.Item>
                                                                                </div >

                                                                                {
                                                                                    blockItemPosition === (blockItemsArray.length - 1) ? (
                                                                                        <>
                                                                                            {closingRemarks}
                                                                                        </>
                                                                                    ) : null
                                                                                }
                                                                            </>
                                                                        )
                                                                    }
                                                                }}
                                                            />
                                                        )
                                                    })()}
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="w-full md:h-full flex flex-row py-10 justify-center align-middle items-center">
                                            <Loading />
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="text-center w-full lg:h-full bg-inherit rounded-md lg:flex flex-col px-4 py-2">
                        <div className="w-full flex-none lg:flex md:flex-row flex-col align-middle lg:items-center">
                            <div className="flex-grow">
                                <p className="text-xl text-primary font-medium text-start">
                                    Attributes
                                </p>
                            </div>
                        </div>

                        <div className="lg:flex-grow w-full lg:h-full flex items-center justify-center">
                            <div className='flex md:flex-col flex-col-reverse'>
                                <div role="status" className="md:w-64 md:h-64 h-44 w-full bg-gree-100 rounded relative">
                                    <div className="absolute w-40 hidden md:block rounded-full bg-inherit border border-gray-200 dark:border-slate-600 h-40 top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2"></div>
                                    <div className="absolute w-56 hidden md:block rounded-full bg-inherit border border-gray-200 dark:border-slate-600 h-56 top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2"></div>
                                    <div className="absolute w-72 hidden md:block rounded-full bg-inherit border border-gray-200 dark:border-slate-600 h-72 top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2"></div>
                                    <div className="w-2/3 h-28 rounded-md bg-white shadow-lg absolute p-3 top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2"></div>

                                    <div className="absolute w-full bg-inherit z-[1] px-4 h-full flex flex-col items-center justify-center">
                                        <div className="w-full bg-white shadow-lg relative">

                                        </div>

                                        <div className="w-full border border-gray-100 shadow-lg rounded-lg p-2 bg-white flex items-center gap-x-2">
                                            <div className="flex-none w-16 rounded-md h-16 bg-gray-200"></div>

                                            <div className="flex-grow w-full flex flex-col gap-y-3">
                                                <div className="h-2.5 bg-gray-200 rounded-full w-2/3"></div>
                                                <div className="h-2.5 bg-gray-200 rounded-full w-full"></div>
                                                <div className="h-2.5 bg-gray-200 rounded-full w-full"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="w-full">
                                    <span className="block text-base text-primary pt-10 font-medium">
                                        Select an asset type from the list
                                    </span>
                                    <span className="block text-muted">
                                        to view configured details
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            <AddAttribute
                type={type}
                category={category}
                show={state.show.addAttribute}
                onComplete={onAddAttributeComplete}
                showOrHide={toggleAddAttributeModal}
            />

            <SingleActionModal
                size="lg"
                posting={state.posting}
                show={false}
                showOrHide={onConsentAction}
                actionName={'Continue'}
                execAction={onConsentAction}
                content={
                    <>
                        <div className="space-y-3">
                            <div className="w-full">
                                <div className="sm:col-span-8 lg:col-span-7">
                                    <h2 className="text-lg text-slate-700 dark:text-slate-200 mb-2">
                                        {/* A draft exists with unpublished changes. */}
                                        Unpublished Changes Detected
                                    </h2>

                                    <p className="text-sm">

                                    </p>
                                </div>
                            </div>

                            <label className="block text-sm font-edium text-gray-700 dark:text-gray-300">
                                What would you like to do?
                            </label>
                            <div className="flex gap-4 md:flex-row flex-col">
                                {
                                    unpublishedChoices.map((option, index) => (
                                        <div className="flex-1" key={`unpub-chng-${index}`}>
                                            <RadioButton
                                                value={option.key}
                                                name={"example"}
                                                required={false}
                                                disabled={false}
                                                checked={draftProps.action === option.key}
                                                changeHandler={handleSelection}
                                                label={
                                                    <>
                                                        <p className="text-sm font-medium">
                                                            {option.label}
                                                        </p>

                                                        <div className="flex items-end justify-between text-gray-500 dark:text-gray-400 py-2">
                                                            <p className="text-sm font-normal">
                                                                {option.subtitle}
                                                            </p>
                                                        </div>
                                                    </>
                                                }
                                            />
                                        </div>
                                    ))
                                }
                            </div>
                            <p className="text-xs py-2 italic">
                                <span className="block">
                                    💡 Discarding will permanently delete all unpublished changes.
                                </span>
                            </p>
                        </div>
                    </>
                }
            />

            <AssetFormPreview
                type={type}
                category={category}
                show={state.show.preview}
                showOrHide={togglePreviewModal}
            />
        </React.Fragment >
    )
}